export enum SentryTags {
  PageName = "page",
}

// Allowlisted query param keys to forward to Sentry as tags.
// Keep this list low-cardinality and non-PII.
export const SENTRY_QUERY_PARAMS_ALLOWLIST = [
  "tab",
  "nodeId",
  "eventType",
] as const;
export type SentryQueryParamKey =
  (typeof SENTRY_QUERY_PARAMS_ALLOWLIST)[number];

// Namespace for tags created from query params to avoid collisions.
export const SENTRY_QUERY_PARAM_TAG_PREFIX = "query_param.";
